import {adminHttpClient} from "../commons/adminHttpClient";


const getLiveBroadcastView = (id : string) : Promise<any> => {
    return adminHttpClient.get(`/LiveBroadcastAudits/View/${id}`);
}

export default getLiveBroadcastView;